export const SET_STUDIO_ADMIN_USER_INFO = 'PRO/SET_STUDIO_ADMIN_USER_INFO'
export type SET_STUDIO_ADMIN_USER_INFO = typeof SET_STUDIO_ADMIN_USER_INFO

export const CLEAR_STUDIO_ADMIN_USER_INFO = 'PRO/CLEAR_STUDIO_ADMIN_USER_INFO'
export type CLEAR_STUDIO_ADMIN_USER_INFO = typeof CLEAR_STUDIO_ADMIN_USER_INFO
